export default "__VITE_ASSET__23875e0a__"